export default __webpack_public_path__ + "static/media/s4.789fdfa6.jpg";